import modalActions from '../redux/modal/actions';

class AccessDeniedModalManager {
  private isModalOpen: boolean = false;
  private debounceTimer: NodeJS.Timeout | null = null;
  private store: any = null;

  setStore(store: any) {
    this.store = store;
  }

  showModal(statusCode: number, customMessage?: string) {
    if (this.isModalOpen) {
      return;
    }

    if (!this.store) {
      console.error('Store not set in AccessDeniedModalManager');
      return;
    }

    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }

    this.debounceTimer = setTimeout(() => {
      if (this.isModalOpen) {
        return;
      }

      this.isModalOpen = true;
      
      this.store.dispatch(modalActions.openModal({
        modalType: 'ACCESS_DENIED',
        modalProps: {
          statusCode,
          customMessage,
          onClose: () => {
            this.isModalOpen = false;
            this.store.dispatch(modalActions.closeModal());
          }
        }
      }));
    }, 100); // 100ms debounce delay
  }

  hideModal() {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = null;
    }
    
    this.isModalOpen = false;
    
    if (this.store) {
      this.store.dispatch(modalActions.closeModal());
    }
  }
}

const accessDeniedModalManager = new AccessDeniedModalManager();

export default accessDeniedModalManager;
